import React from "react";
import { Component } from "react";
import { Popper, Reference, Manager } from "react-popper";

// STYLES
import styled from "styled-components";

// COMPONENTS
import Input from "./Input.js";
import Type from "./Typography.js";
import { NanoFlex } from "./NanoFlex.js";

// IMAGES
import { ReactComponent as ArrowUp } from "../../images/Icons/upArrow.svg";
import { ReactComponent as ArrowDown } from "../../images/Icons/downArrow.svg";
import { ReactComponent as Delete } from "../../images/Icons/delete.svg";
import { ReactComponent as Search } from "../../images/Icons/search.svg";

// UTILS
import { elementMatchesAny } from "../../tools.js";

const StyledBlockBox = styled.div``;

const BlockBox = (props) => (
  <StyledBlockBox
    className={props.selected ? "blockBox selected" : "blockBox"}
    onClick={(e) => {
      /*Prevent Click on Delete Icon*/
      if (elementMatchesAny(e.target, [".deleteIcon"])) return;
      return props.blockBoxAction(props.index);
    }}
    selected={props.selected}
  >
    {props.content && (
      <NanoFlex className="dropDownLine" justifyContent={"flex-start"}>
        {/* <Check /> */}
        {props.customContent && props.customContent()}
        {!props.customContent && <Type.p>{props.content}</Type.p>}
        {props.delete && (
          <NanoFlex className="deleteIcon" onClick={() => props.deleteAction()}>
            <Delete />
          </NanoFlex>
        )}
      </NanoFlex>
    )}
  </StyledBlockBox>
);

const StyledSingleSelection = styled.div``;

class SingleSelectionDropdown extends Component {
  constructor(props) {
    super(props);
    let options = this.props.options ? this.props.options : [];
    this.state = {
      term: "",
      hasSearch: this.props.searchable ?? false,
      options: options,
      selected: this.props.selected,
      isOpenDropdown: false,
    };

    this.nodeRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected) {
      this.triggerOnChangeSelection();
    }
    if (
      JSON.stringify(prevProps.selected) !==
        JSON.stringify(this.props.selected) ||
      this.props.forceSelection
    ) {
      this.setState({ selected: this.props.selected });
    }
    if (prevProps.options !== this.props.options) {
      this.setState({ options: this.props.options });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (!this.nodeRef.current.contains(e.target))
      this.setState({ isOpenDropdown: false });
  };

  triggerOnChangeSelection = () => {
    if (this.props.onChangeSelection) {
      this.props.onChangeSelection(
        this.state.options.find((v) => {
          return this.state.selected === v.id;
        })
      );
    }
  };

  onOptionClick = (v) => {
    this.setState({
      selected: this.state.selected !== v ? v : null,
      isOpenDropdown: false,
    });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  getDisplayString = () => {
    /*Add Custom Display String*/
    if (this.props.customDisplayString) {
      var event = {
        handled: false,
        selected: this.state.selected,
        displayString: null,
      };
      this.props.customDisplayString(event);
      if (event.handled) return event.displayString;
    }
    if (!this.state.selected) return "";

    return this.state.options.find((v) => {
      return this.state.selected === v.id;
    }).name;
  };

  getFilteredResults = () => {
    if (this.state.term.trim() !== "") {
      let upperTerm = this.state.term.trim().toUpperCase();
      return this.state.options.filter((v) => {
        let upperName = v.name.trim().toUpperCase();
        return upperName.includes(upperTerm);
      });
    } else {
      return this.state.options;
    }
  };

  render() {
    let displayString = this.getDisplayString();
    let filteredResults = this.getFilteredResults();
    return (
      <StyledSingleSelection
        ref={this.nodeRef}
        className="dropDownContainer"
        displayString={displayString}
        indicator={this.state.selected}
        error={this.props.error}
      >
        <NanoFlex className="dropDownWrapper">
          <Manager>
            <Reference>
              {(targetProps) => {
                return (
                  <NanoFlex
                    ref={targetProps.ref}
                    className="inputDropDownWrapper"
                    justifyContent={"flex-start"}
                    alignItems={"flex-start"}
                    onClick={() => {
                      this.setState({
                        isOpenDropdown: !this.state.isOpenDropdown,
                      });
                    }}
                  >
                    <NanoFlex
                      className="infoDropDownWrapper"
                      justifyContent={"flex-start"}
                    >
                      <Type.p>
                        {displayString ? displayString : "Select an option"}
                      </Type.p>
                    </NanoFlex>
                    <NanoFlex className="iconDropDownWrapper">
                      {this.state.isOpenDropdown ? (
                        <ArrowUp />
                      ) : (
                        <ArrowDown className="svgMargin" />
                      )}
                    </NanoFlex>
                  </NanoFlex>
                );
              }}
            </Reference>
            {this.state.isOpenDropdown && (
              <Popper placement={"bottom"}>
                {({ ref, style, placement, arrowProps }) => (
                  <NanoFlex
                    ref={ref}
                    style={style}
                    data-placement={placement}
                    className="dropDownContentWrapper"
                    flexDirection={"column"}
                    justifyContent={"flex-start"}
                  >
                    {this.state.hasSearch && (
                      <NanoFlex className="inputSearchWrapper">
                        <Input
                          title={null}
                          defaultValue={this.state.term}
                          placeholder={"Search..."}
                          onChangeAction={this.onTermChange}
                        />
                        <NanoFlex className="searchIconWrapper">
                          <Search />
                        </NanoFlex>
                      </NanoFlex>
                    )}
                    {filteredResults.length === 0 && (
                      <NanoFlex className="noResults">
                        <Type.p>No Results</Type.p>
                      </NanoFlex>
                    )}
                    {filteredResults.map((v, i) => {
                      return (
                        <BlockBox
                          key={`${i}_${v.id}`}
                          content={v.name}
                          selected={this.state.selected === v.id}
                          blockBoxAction={() => {
                            this.onOptionClick(v.id);
                          }}
                          delete={this.props.onDeleteClick ? true : false}
                          deleteAction={() => {
                            this.props.onDeleteClick(v.id);
                          }}
                          customContent={
                            this.props.customContent
                              ? () => {
                                  return this.props.customContent(v);
                                }
                              : null
                          }
                        />
                      );
                    })}
                  </NanoFlex>
                )}
              </Popper>
            )}
          </Manager>
        </NanoFlex>
      </StyledSingleSelection>
    );
  }
}

export default SingleSelectionDropdown;
